import React from "react";

import { Header, Icon } from "semantic-ui-react";

function SubscriptionOutdated() {
  return (
    <div data-test="subscription-outdated-container">
      <Header>Subscription</Header>
      <div style={{ display: "flex", marginBottom: "0.8em" }}>
        <Icon name="exclamation triangle" color="yellow" size="large" />
        <div style={{ marginLeft: "0.5em" }}>
          Oops, we have not yet updated your subscription with the latest
          information. Please revisit this page at a later time. Your patience
          is appreciated!
        </div>
      </div>
    </div>
  );
}

export default SubscriptionOutdated;
